import { render, staticRenderFns } from "./TransportCompany.vue?vue&type=template&id=0d067e2c"
import script from "./TransportCompany.vue?vue&type=script&lang=js"
export * from "./TransportCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports